import StockOrderShipmentCard from '../StockOrderShipmentCard/StockOrderShipmentCard';
import { ICountry, IStockOrderDetail } from '../../../../../../../types/stockOrders';
import './TrackingInfo.scss';

const TrackingInfo = ({
  shipments,
  orderId,
  country,
  updateWithoutLoaders
}: {
  shipments: IStockOrderDetail['generalData']['shipments'];
  orderId: number;
  country: ICountry;
  updateWithoutLoaders: () => Promise<void>;
}) => {
  return (
    <div className="trackingInfo">
      <div className="trackingTitle">Tracking de envíos</div>
      <section className="shipmentInfo">
        {shipments?.map(shipment => (
          <StockOrderShipmentCard
            stockOrderId={orderId}
            shipment={shipment}
            shipments={shipments}
            key={shipment.stockShipmentId}
            isEnabled
            updateWithoutLoaders={updateWithoutLoaders}
            country={country}
          />
        ))}
      </section>
    </div>
  );
};

export default TrackingInfo;
